import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Textbox icon.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const TextboxIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M15.7197 6.78125V5.56738C15.7197 5.082 15.3278 4.6875 14.8389 4.6875H5.15918C4.67384 4.68756 4.27936 5.07853 4.2793 5.56738V6.78125C4.27907 7.0572 4.0553 7.28125 3.7793 7.28125C3.50329 7.28125 3.27952 7.0572 3.2793 6.78125V5.56738C3.27936 4.5231 4.1247 3.68756 5.15918 3.6875H14.8389C15.8832 3.6875 16.7197 4.53287 16.7197 5.56738V6.78125C16.7195 7.05706 16.4955 7.28102 16.2197 7.28125C15.9437 7.28125 15.72 7.0572 15.7197 6.78125Z"
      fill="currentColor"
    />
    <path
      d="M9.49902 15.8135V4.74023C9.49902 4.46409 9.72288 4.24023 9.99902 4.24023C10.2752 4.24023 10.499 4.46409 10.499 4.74023V15.8135C10.499 16.0896 10.2752 16.3135 9.99902 16.3135C9.72288 16.3135 9.49902 16.0896 9.49902 15.8135Z"
      fill="currentColor"
    />
    <path
      d="M12.625 15.3125C12.9011 15.3125 13.125 15.5364 13.125 15.8125C13.125 16.0886 12.9011 16.3125 12.625 16.3125H7.37207C7.09593 16.3125 6.87207 16.0886 6.87207 15.8125C6.87207 15.5364 7.09593 15.3125 7.37207 15.3125H12.625Z"
      fill="currentColor"
    />
  </svg>
);

export default TextboxIcon;
